function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Box } from '../../components/internal';
import { forwardRef } from '../../utils';
import { useStyleConfig } from '../../utils/use-style-config';
import { jsx as _jsx } from "react/jsx-runtime";
export var _GroupItem = forwardRef((_ref, ref) => {
  var {
    children,
    order,
    grow,
    shrink,
    basis,
    alignSelf
  } = _ref;
  var style = useStyleConfig('GroupItem', {
    order,
    grow,
    shrink,
    basis,
    alignSelf
  });
  var child = React.Children.only(children);
  var props = {
    'data-component': 'Group.Item',
    ref,
    __css: style
  };
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, props), {}, {
    children: child
  }));
});
_GroupItem.displayName = 'Group.Item';
//# sourceMappingURL=_GroupItem.js.map